import { render, staticRenderFns } from "./InputPositiveInt.vue?vue&type=template&id=6c2452e0&"
import script from "./InputPositiveInt.vue?vue&type=script&lang=js&"
export * from "./InputPositiveInt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports